import axios from 'axios';

const API_BASE_URL = '/api';

export const commentService = {
    // Get comments for a post
    getComments: async (slug, params = {}) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/posts/${slug}/comments`, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching comments:', error);
            throw error;
        }
    },

    // Submit a new comment
    submitComment: async (slug, data) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/posts/${slug}/comments`, data);
            return response.data;
        } catch (error) {
            console.error('Error submitting comment:', error);
            throw error;
        }
    },
};
